'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.error = exports.success = exports.start = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _normalize = require('../utils/normalize');

var _normalize2 = _interopRequireDefault(_normalize);

var _is = require('../utils/is');

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uniqEs6 = function uniqEs6(arrArg) {
  return arrArg.filter(function (elem, pos, arr) {
    return arr.indexOf(elem) == pos;
  });
};

/**
 * The start action for the fetch reducer
 * @param  {Immutable.Map} state - current reducer state
 * @param  {Object} action - action object
 *
 * @return {Immutable.Map} - updated state
 */
var start = exports.start = function start(state, action) {
  var params = action.params;
  return state.withMutations(function (map) {

    // Add additional data if provided
    //if(action.additionalData) {
    //map.mergeIn(['instances', action.instance, 'additionalData'], Immutable.fromJS(action.additionalData))
    map.mergeIn(['instances', action.instance, 'additionalData'], _immutable2.default.fromJS(_extends({}, action.additionalData, {
      error: false,
      errorMessage: null,
      isFetching: !params || params._id === undefined ? true : false,
      isFetchingSingle: params && params._id !== undefined ? true : false
    })));
    //}
  });
};

/**
 * The success action for the fetch reducer
 * @param  {Immutable.Map} state - current reducer state
 * @param  {Object} action - action object
 *
 * @return {Immutable.Map} - updated state
 */
var success = exports.success = function success(state, action) {
  var responseData = action.responseData;

  return state.withMutations(function (map) {
    // Do nothing if no response data is provided
    if (!responseData) {
      return;
    }

    // Convert responseData to array if object is provided
    if ((0, _is.isObject)(responseData)) {
      responseData = [responseData];
    }

    // If the returned data is an array we normalize and add each item
    if (Array.isArray(responseData)) {

      // Merge new raw data with existing raw data
      var normalizedData = (0, _normalize2.default)(action.uidField, _immutable2.default.fromJS(responseData));
      map.set('raw', map.get('raw').mergeDeep(normalizedData));
    }

    // Update instance array with new data
    var instanceData = _immutable2.default.fromJS(responseData.map(function (i) {
      return i[action.uidField].toString();
    }));

    // Append if options.appendResponse is true
    if (action.options.appendResponse) {
      var existingInstanceData = map.getIn(['instances', action.instance, 'data'], (0, _immutable.List)());

      var mergedData = existingInstanceData && uniqEs6(existingInstanceData.concat(instanceData));

      map.setIn(['instances', action.instance, 'data'], _immutable2.default.fromJS(mergedData));
    }
    // Otherwise we replace the data with the fetch response
    else {
        map.setIn(['instances', action.instance, 'data'], instanceData);
      }

    //const instanceTotal = map.getIn(['instances', action.instance, 'data'], List());
    //console.log(`instanceTotal:`, instanceTotal);

    // Add additional data if provided
    //if(action.additionalData) {
    //map.mergeIn(['instances', action.instance, 'additionalData'], Immutable.fromJS(action.additionalData));
    map.mergeIn(['instances', action.instance, 'additionalData'], _immutable2.default.fromJS(_extends({}, action.additionalData, {
      error: false,
      errorMessage: null,
      isFetching: false,
      isFetchingSingle: false
      //...(action.options && action.options.recalcTotal) && { total: instanceTotal.size },
    })));
    //}
  });
};

/**
 * The error action for the fetch reducer
 * @param  {Immutable.Map} state - current reducer state
 * @param  {Object} action - action object
 *
 * @return {Immutable.Map} - updated state
 */
var error = exports.error = function error(state, action) {
  return state.withMutations(function (map) {

    // Add additional data if provided
    //if(action.additionalData) {
    //map.mergeIn(['instances', action.instance, 'additionalData'], Immutable.fromJS(action.additionalData));
    map.mergeIn(['instances', action.instance, 'additionalData'], _immutable2.default.fromJS(_extends({}, action.additionalData, {
      error: true,
      errorMessage: action.responseData,
      isFetching: false,
      isFetchingSingle: false
    })));
    //}
  });
};

exports.default = {
  start: start,
  success: success,
  error: error
};